import Vue from "vue";
import VueI18n from "vue-i18n";
import { ru, uz, yo, zu, af, en, fl, ig, ka, ky, kk, ne } from "@/translations";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "ru",
  fallbackLocale: "ru",
  silentTranslationWarn: process.env.NODE_ENV === "production",
  messages: { ru, uz, yo, zu, af, en, fl, ig, ka, ky, kk, ne }
});

export default i18n;
